import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutService } from '../../../services/layout.service';

@Component({
  selector: 'col-1',
  templateUrl: './col-1.component.html',
  styleUrls: ['./col-1.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class Col1Component implements OnChanges {
  @Input() index: any;
  @Input() components: any[];
  @Input() footer: any;
  @Input() edit: boolean;
  @Input() widgetEdit: boolean;
  @Output() component = new EventEmitter<any>();

  editComponentWidget = [
    {
      typeOf: 'showcase',
      height: '95vh',
      width: '80vw',
      value: 'showcase',
      name: 'Showcase Carousel',
      selected: false,
      dynamic: true,
    },
  ];

  editComponentListFooter = [
    {
      typeOf: 'cta',
      height: '100vh',
      width: '95vw',
      value: 'cta',
      name: 'Call to Action',
      selected: false,
    },
    {
      typeOf: 'text',
      height: '95vh',
      width: '90vw',
      value: 'text',
      name: 'Text Block',
      selected: false,
    },
    {
      typeOf: 'image',
      height: '95vh',
      width: '90vw',
      value: 'image',
      name: 'Image Block',
      selected: false,
    },
  ];
  editComponentList = [
    {
      typeOf: 'cta',
      height: '100vh',
      width: '95vw',
      value: 'cta',
      name: 'Call to Action',
      selected: false,
    },
    {
      typeOf: 'image',
      height: '95vh',
      width: '90vw',
      value: 'image',
      name: 'Image Block',
      selected: false,
    },
    {
      typeOf: 'showcase-list',
      height: '95vh',
      width: '80vw',
      value: 'showcase-list',
      name: 'List Carousel',
      selected: false,
      dynamic: false,
    },
    {
      typeOf: 'showcase',
      height: '95vh',
      width: '80vw',
      value: 'showcase',
      name: 'Showcase Carousel',
      selected: false,
      dynamic: true,
    },
    {
      typeOf: 'popular-list',
      height: 'auto',
      width: '80vw',
      value: 'popular-list',
      name: 'Popular Carousel',
      selected: false,
      dynamic: true,
    },
    {
      typeOf: 'feedback',
      height: '95vh',
      width: '90vw',
      value: 'feedback',
      name: 'Feed Back',
      selected: false,
    },
    {
      typeOf: 'text',
      height: '95vh',
      width: '90vw',
      value: 'text',
      name: 'Text Block',
      selected: false,
    },
    {
      typeOf: 'embed',
      height: '85vh',
      width: '90vw',
      value: 'embed',
      name: 'Embed Web Link',
      selected: false,
    },
  ];

  constructor(
    public dialog: MatDialog,
    private _layoutService: LayoutService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes) {
      return;
    }

    if (changes.index) {
      this.index = changes.index.currentValue;
    }
    if (changes.footer) {
      this.footer = changes.footer.currentValue;
      if (this.footer == 'true') {
        this.editComponentList = this.editComponentListFooter;
      }
    }
    if (changes.widgetEdit?.currentValue) {
      this.editComponentList = this.editComponentWidget;
    }
  }

  openSideNav(typeOf, compArray, template, row, edit) {
    if (typeOf === 0) {
      // do nothing on first value.
      return;
    }

    const data = {
      typeOf: typeOf,
      rowType: row,
      rowArray: this.index,
      compArray: compArray,
      template: template,
      edit: edit,
      dynamic: false,
      widgetEdit: this.widgetEdit,
    };
    switch (typeOf) {
      case 'showcase':
        data.typeOf = typeOf;
        data.dynamic = true;
        break;
      case 'showcase-list': // for list showcase
        data.typeOf = 'showcase-list';
        break;
      case 'popular-list': // for popular showcase
        data.typeOf = 'popular-list';
        break;
    }

    this._layoutService.openSideNav({
      template: 'comp',
      position: 'start',
      data: data,
      mode: 'side',
    });
  }
}
